var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarginSidesXl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_48)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 20,
    width: 104,
    height: 58,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 20,
    width: 104,
    height: 58,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64645 48.6464C7.45118 48.8417 7.45118 49.1583 7.64645 49.3536L10.8284 52.5355C11.0237 52.7308 11.3403 52.7308 11.5355 52.5355C11.7308 52.3403 11.7308 52.0237 11.5355 51.8284L8.70711 49L11.5355 46.1716C11.7308 45.9763 11.7308 45.6597 11.5355 45.4645C11.3403 45.2692 11.0237 45.2692 10.8284 45.4645L7.64645 48.6464ZM38.3536 49.3536C38.5488 49.1583 38.5488 48.8417 38.3536 48.6464L35.1716 45.4645C34.9763 45.2692 34.6597 45.2692 34.4645 45.4645C34.2692 45.6597 34.2692 45.9763 34.4645 46.1716L37.2929 49L34.4645 51.8284C34.2692 52.0237 34.2692 52.3403 34.4645 52.5355C34.6597 52.7308 34.9763 52.7308 35.1716 52.5355L38.3536 49.3536ZM8 49.5H38V48.5H8V49.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.646 48.6464C157.451 48.8417 157.451 49.1583 157.646 49.3536L160.828 52.5355C161.024 52.7308 161.34 52.7308 161.536 52.5355C161.731 52.3403 161.731 52.0237 161.536 51.8284L158.707 49L161.536 46.1716C161.731 45.9763 161.731 45.6597 161.536 45.4645C161.34 45.2692 161.024 45.2692 160.828 45.4645L157.646 48.6464ZM188.354 49.3536C188.549 49.1583 188.549 48.8417 188.354 48.6464L185.172 45.4645C184.976 45.2692 184.66 45.2692 184.464 45.4645C184.269 45.6597 184.269 45.9763 184.464 46.1716L187.293 49L184.464 51.8284C184.269 52.0237 184.269 52.3403 184.464 52.5355C184.66 52.7308 184.976 52.7308 185.172 52.5355L188.354 49.3536ZM158 49.5L188 49.5V48.5L158 48.5V49.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginSidesXl);
export default __webpack_public_path__ + "static/media/margin_sides_xl.7fd5114029aa2483cf9b1ea74e6020f4.svg";
export { ForwardRef as ReactComponent };